import React, { useState } from 'react';
import Lottie from 'lottie-react';
import distancing from '../../static/lotties/distancing.json';
import handglove from '../../static/lotties/glove.json';
import handSanitizer from '../../static/lotties/sanitizer.json';
import bag from '../../static/lotties/soap-bag.json';
import AnimateHeight from 'react-animate-height';
import DownArrow from './components/DownArrow';

const CovidResponseSection = () => {
  const [display, setDispay] = useState(false);
  const [height, setHeight] = useState(0);

  const handleHeightToggle = () => {
    setHeight((prev) => (prev === 0 ? 'auto' : 0));
    setDispay(!display);
  };

  const handleDisplay = () => {
    setDispay(!display);
  };
  return (
    <section
      className='pt-[50px] pb-[0px] -mb-[50px]  bg-black py-11 px-4 lg:px-0 '
      id='footer'
      // data-aos='fade'
      // data-aos-delay='50'
      // data-aos-duration='500'
    >
      <div className='max-w-[1050px] mx-auto  flex items-center justify-center text-white'>
        <div className='w-full'>
          <div className='flex items-center justify-between w-full mb-10'>
            <h6 className='text-xl text-JeetarRed'>Our response to Covid-19</h6>
            <span onClick={handleHeightToggle} className={`cursor-pointer`}>
              <DownArrow display={display} />
            </span>
          </div>
          <AnimateHeight
            id='covid-response'
            duration={300}
            easing='ease'
            height={height} // see props documentation below
          >
            <div>
              <div className='grid grid-cols-1 gap-1 pt-0 pb-12 space-y-10 text-sm text-left border-t border-b border-gray-800 lg:text-base lg:space-y-1 lg:grid-cols-4'>
                <div className='flex flex-col justify-center space-y-4'>
                  <Lottie
                    animationData={bag}
                    className='w-24 h-24 -ml-4 bg-transparent'
                  />
                  <p>All items are neatly packed in perfect conditions.</p>
                </div>
                <div className='flex flex-col justify-center space-y-4'>
                  <Lottie
                    animationData={handSanitizer}
                    className='w-20 h-20 mt-8 -ml-6 bg-transparent'
                  />
                  <p className=''>
                    We clean and sanitize our hands before sending your orders
                    to your doorstep.
                  </p>
                </div>
                <div className='flex flex-col justify-center -mb-2 space-y-4'>
                  <Lottie
                    animationData={distancing}
                    className='w-20 h-20 mt-1 -ml-1 bg-transparent'
                  />
                  <p>
                    Our highly trained riders observe social distancing at all
                    times
                  </p>
                </div>
                <div className='flex flex-col justify-center space-y-4'>
                  <Lottie
                    animationData={handglove}
                    className='w-20 h-20 -ml-2 bg-transparent'
                  />
                  <p>We practice regular hand washing at Jeetar</p>
                </div>
              </div>
              {/* <p className='py-8 text-[#A8A8A8] text-sm lg:text-base'>
                Cras nulla interdum neque ullamcorper. Vitae adipiscing purus,
                tellus bibendum morbi ipsum, orci commodo. Tellus bibendum morbi
                ipsum, orci commodo ellus bibendum morbi ipsum, orci commodo
              </p> */}
            </div>
          </AnimateHeight>
        </div>
      </div>
      <div className='border-t border-gray-800'></div>
    </section>
  );
};

export default CovidResponseSection;
